import { useEffect, useState, useContext } from "react";
import { Button, Col, Dropdown, Row } from "antd";
import {
  DownOutlined,
  KeyOutlined,
  LogoutOutlined,
  UserOutlined,
} from "@ant-design/icons";

import { useNavigate } from "react-router-dom";
import DeleteModal from "../../components/DeleteModal";
import LogoImage from "../../assets/images/eats-tots-logo.svg";
import { AuthContext } from "../../context/AuthContext";

const toggler = [
  <svg
    width="20"
    height="20"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 448 512"
    key={0}
  >
    <path d="M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"></path>
  </svg>,
];

function Header({ onPress, setToggle }) {
  const { logout, userProfile: ctxUserProfile } = useContext(AuthContext);
  const navigate = useNavigate();
  const [isLogoutModalVisible, setIsLogoutModalVisible] = useState(false);

  // Prefer context (so updates apply immediately), but keep localStorage as fallback.
  const userProfile =
    ctxUserProfile || JSON.parse(localStorage.getItem("userProfile") || "{}");
  const userName = userProfile?.name || userProfile?.email || "Admin";
  const computedProfilePic =
    userProfile?.profilePic ||
    userProfile?.profileImage ||
    userProfile?.avatar ||
    null;

  // If the S3 URL is invalid/blocked, the browser would show a broken-image icon.
  // We switch to the fallback icon using this "safe" state.
  const [safeProfilePic, setSafeProfilePic] = useState(computedProfilePic);
  useEffect(() => {
    setSafeProfilePic(computedProfilePic);
  }, [computedProfilePic]);

  const userMenuItems = [
    {
      key: "profile",
      label: (
        <span>
          <UserOutlined style={{ marginRight : "8px" }} />
          Manage Profile
        </span>
      ),
      onClick: () => navigate("/profile"),
    },
    {
      key: "password",
      label: (
        <span>
          <KeyOutlined style={{ marginRight : "8px" }} />
          Change Password
        </span>
      ),
      onClick: () => navigate("/change-password"),
    },
    {
      key: "logout",
      label: (
        <span>
          <LogoutOutlined style={{ marginRight : "8px" }} />
          Logout
        </span>
      ),
      onClick: () => setIsLogoutModalVisible(true),
    },
  ];

  return (
    <>
      <Row className="align-items-center">
        <Col span={24} xs={18} md={18}>
          <div className="toggale-headr">
            <div className="moblile-toggle d-lg-none">
              <Button
                type="link"
                className="sidebar-toggler"
                onClick={() => onPress()}
              >
                {toggler}
              </Button>
            </div>
            <div className="">
              <Button
                type="link"
                className="sidebar-toggler ps-0 d-none d-lg-block"
                onClick={() => setToggle()}
              >
                {toggler}
              </Button>
            </div>
            <div className="tabLogo d-flex align-items-center" style={{ marginLeft: 8 }}>
              <img
                src={LogoImage}
                alt="Project.Kitchen"
                style={{ height: 28, marginRight: 8 }}
              />
              {/* <h4>Project.Kitchen</h4> */}
            </div>
          </div>
        </Col>
        <Col span={24} xs={6} md={6} className="header-control">
          <div className="d-flex align-items-center justify-content-end gap-2">
            <div className="profileDropdownMain">
              <span className="d-none d-md-inline" style={{ marginRight : "8px" }}>
                Welcome, {userName}
              </span>
              <Dropdown
                menu={{ items: userMenuItems }}
                placement="bottomRight"
                trigger={["click"]}
                overlayClassName="profileDropdownMenu"
                getPopupContainer={() => document.body}
              >
                <span
                  className="profileDropdownTrigger"
                  aria-label="Open admin menu"
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") e.preventDefault();
                  }}
                >
                  {safeProfilePic ? (
                    <img
                      src={safeProfilePic}
                      alt="Profile"
                      className="header-user-avatar"
                      onError={() => setSafeProfilePic(null)}
                    />
                  ) : (
                    <UserOutlined
                      className="header-user-icon"
                      style={{ color: "#fff", fontSize: 16 }}
                    />
                  )}
                  <DownOutlined style={{ fontSize: 12, color: "#fff" }} />
                </span>
              </Dropdown>
            </div>
          </div>
        </Col>
      </Row>
      {isLogoutModalVisible && (
        <DeleteModal
          title={"Logout"}
          subtitle={`Are you sure you want to logout?`}
          show={isLogoutModalVisible}
          hide={() => {
            setIsLogoutModalVisible(false);
          }}
          onOk={() => {
            logout();
          }}
        />
      )}
    </>
  );
}

export default Header;
